import app from 'flarum/forum/app';
import Page from 'flarum/common/components/Page';
import loadTools from '../service/toolApi';
export default class ToolsPage extends Page {
  oninit(vnode) {
    super.oninit(vnode);
    this.tools = [];
    this.loading = true;
    loadTools().then(response => {
      this.tools = response.data || [];
    }).catch(() => {
      this.tools = [];
    }).finally(() => {
      this.loading = false;
      m.redraw();
    });
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    app.setTitle('Инструменты разработчика');
  }
  view() {
    return m('main.dc-directory', {
      'aria-labelledby': 'dc-tools-title'
    }, [m('section.dc-directory__hero', m('div.dc-container', [m('span', 'Каталог DevConnect'), m('h1#dc-tools-title', 'Инструменты разработчика'), m('p', 'Только то, что решает конкретную задачу. Для каждого инструмента объясняем назначение, ограничения и с чего начать.')])), m('section.dc-container.dc-directory__grid', this.content())]);
  }
  content() {
    if (this.loading) {
      return m('div.dc-directory__empty', [m('h2', 'Загружаем каталог…')]);
    }
    if (!this.tools.length) {
      return m('div.dc-directory__empty', [m('h2', 'Каталог готов к наполнению'), m('p', 'Проверенные инструменты появятся после редакторской проверки.')]);
    }

    // Карточка показывает только проверенные сервером значения и безопасные внешние ссылки.
    return this.tools.map(tool => m('article.dc-tool-card', [m('div.dc-tool-card__icon', (tool.name || '?').slice(0, 1).toLocaleUpperCase('ru-RU')), m('div.dc-tool-card__body', [m('div.dc-tool-card__meta', [m('span', tool.category), tool.license ? m('span', tool.license) : null]), m('h2', tool.name), m('p', tool.summary), m('div.dc-tool-card__tags', (tool.tags || []).map(tag => m('span', tag))), m('footer', [m('a', {
      href: tool.websiteUrl,
      target: '_blank',
      rel: 'noopener noreferrer nofollow'
    }, 'Открыть сайт ↗'), tool.discussionUrl ? m('a', {
      href: tool.discussionUrl
    }, 'Обсудить') : null])])]));
  }
}
flarum.reg.add('devconnect-tools', 'forum/components/ToolsPage', ToolsPage);